import React from 'react';

//CORE COMPONENTS
import { ThemeProvider, styled } from '../../../components-core/packages/components-core/dist/theme-provider/index';
import {
    Container,
    ContainerWrap,
    ContainerPadding,
    ContainerGutter,
    ContainerHorizontalAlignment,
    ContainerVerticalAlignment
} from '../../../components-core/packages/components-core/dist/container/index';
import { IntegratorRoot } from '../../../components-core/packages/components-core/dist/integrator-root/index';
import { Text, TextAppearance, TextAlignment, TextColor} from '../../../components-core/packages/components-core/dist/text';
import { Breakpoints } from '../../../components-core/packages/components-core/dist/helpers';
import { Select } from '../../../components-core/packages/components-core/dist/select/index';
import { TextArea } from '../../../components-core/packages/components-core/dist/text-area/index';//CUSTOM COMPONENTS
import { Button, ButtonAppearance} from '../../../components-core/packages/components-core/dist/button';
import { ChevronDown } from '../../../components-core/packages/icons-core/dist/ChevronDown';
import { Mail } from '../../../components-core/packages/icons-core/dist/Mail'
import { Fax } from '../../../components-core/packages/icons-core/dist/Fax'
import { Download } from '../../../components-core/packages/icons-core/dist/Download'


//CUSTOM COMPONENTS
import amarok from './amarok-aventura.png'
import caddy from './caddy-exclusive.png';
import crafter from './crafter-okul.png';
import transporter from './tr-panelvan.png';
import CarImageTitle from '../data-display/CarImageTitle'

const UnorderedList = styled.div`
display: grid;
grid-gap: 52px;
grid-template-columns: repeat(3, 1fr);
list-style: none;

@media screen and (max-width: 960px) {
    grid-template-columns: repeat(2, 1fr);
}

@media screen and (max-width: 560px) {
    grid-template-columns: repeat(2, 1fr);
}
`;

const ClickableDiv = styled.div`
    cursor: pointer;
`;

const Line = styled.div`
    background-color: #dfe4e8;
    width: 100%;
    height: 2px;
`;


const LineTwo = styled.div`
    background-color: #000000;
    width: 100%;
    height: 2px;
`;

const TopContainer = styled.div`
    width: 100vw;
    
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
`;


class ModelTakeCredit extends React.Component {

    constructor() {
        super();
        this.state = {
            stateCredit: 0,
            selectedCar: "-1",

        }

    this.staticContainerPaddingVertical = { 
        top: ContainerPadding.grid001, 
    }

    this.staticContainerPaddingHorizontal = {
        left: ContainerPadding.grid002,
        right: ContainerPadding.grid002,
        ...this.staticContainerPaddingVertical
    }
    }


    renderTitleAndImage() {

        const dummyData = dataListMode1(this.props);
        const newData = [];

        dummyData.forEach(dataObj => {
            if (dataObj.title) {
                newData.push(dataObj);
            }
        })

        return newData.map(data =>
            <li style={{ float: 'left', position: 'relative' }}  
                onClick={() => this.setState({ stateCredit: 1 })}
            >
                <CarImageTitle data={data} />
            </li>
        )

    }

    renderModelName() {

        return (
            <Container
                padding={padding4Dimensions}
                horizontalAlign={ContainerHorizontalAlignment.center}
            >
                <Text bold appearance={TextAppearance.headline0400} >
                    Amarok
                </Text>
 
            </Container>
        )
    }
    renderModelText(){
        return (
            <Container 
                padding={padding4Dimensions} 
                horizontalAlign={ContainerHorizontalAlignment.center} 
            > <ClickableDiv
                    onClick={() => this.setState({ stateCredit: 0 })}
                >
                <Text textAlign={TextAlignment.center} appearance={TextAppearance.copy0200} color={TextColor.inherit} >
            
                        Model Değiştir
                
                </Text></ClickableDiv>
            </Container>
        )
    }

    renderInnerModelContainer(){

        const mainContainerPadding = {
            top: ContainerPadding.dynamic0300,
            bottom: ContainerPadding.dynamic0300
        }
    return(
           <Container 
        padding={mainContainerPadding}
        horizontalAlign={ContainerHorizontalAlignment.center} 
    >
        <Container 
            horizontalAlign={ContainerHorizontalAlignment.center}
            stretchContent={true}
            wrap={ContainerWrap.always}
        >
            {this.renderModelName()}
            {this.renderModelText()}
        </Container>
    </Container>
)

 
    }


    render() {
        const ContainerPaddingGrid = ContainerPadding.grid002;

        if (this.state.stateCredit === 0) {
            return (
                <ThemeProvider>
                    <Container
                        padding={{
                            left: {
                                [Breakpoints.b560]: ContainerPaddingGrid,
                            },
                            right: {
                                [Breakpoints.b560]: ContainerPaddingGrid,
                            }
                        }}
                    >
                        <UnorderedList           
>
                                {this.renderTitleAndImage()}
                        </UnorderedList>
                    </Container>
                </ThemeProvider>

            )
        }
        else if (this.state.stateCredit === 1) {
            const mainContainerPadding = {
                top: ContainerPadding.dynamic0300,
                bottom: ContainerPadding.dynamic0300
            }
    
            return (
                <div>
           <TopContainer>
                    {this.renderInnerModelContainer()}
            </TopContainer>
            <div style={{marginTop:'-100px'}}>
            <Container 
                stretchContent={true} 
                wrap={ContainerWrap.always} 
                gutter={ContainerGutter.dynamic0050}
            >
             <Container 
                stretchContent={true} 
                padding={leftContainerPadding} 
                wrap={ContainerWrap.always}
            >  <Text bold>Model Tipini Seçin</Text><br/>
                    <Select
                    value='Amarok Highline'
                    name="Araba"
                    onChange={(event) => {
                        this.setState({ selectedOption: event.target.value })
                    }}
                    autoComplete={'given-name'}
                    key={this.state.selectedOption + '1'}
                         >
                    <option
                        label={'Seçiniz'}
                        key={"0"}
                    >
                        {'Seçiniz'}
                    </option>
                    {
                        dealerList.map(data => 
                            <option 
                                label={data.carName}
                                key={data.id}
                            >
                                {data.modelName}
                            </option>
                        )
                    }
                </Select><br/>
                <Text bold>Peşinat Tutarı</Text><br/>
                     <TextArea
                    required={true}
                /><br/>   

                <Text bold>Vade Seçenekleri</Text><br/>
                <Select
                    value='12 Ay'
                    name="Vade"
                    onChange={(event) => {
                        this.setState({ selectedOption: event.target.value })
                    }}
                    autoComplete={'given-name'}
                    key={this.state.selectedOption + '1'}
                         >
                    <option
                        label={'Seçiniz'}
                        key={"0"}
                    >
                        {'Seçiniz'}
                    </option>
                    {
                        vadeList.map(data => 
                            <option 
                                label={data.vadeName}
                                key={data.id}
                            >
                                {data.vadeName}
                            </option>
                        )
                    }
                </Select>

                <br/><br/>
            <Line /><br/><br/>
               
               
                 <Button appearance={ButtonAppearance.Primary} wrap={ContainerWrap.always}
>
                    <Text appearance={TextAppearance.copy0150} color={TextColor.secondary}>
                        Hesapla
                    </Text>  
                </Button>
                <br/><br/>
            <Line /><br/><br/>

            <Text bold>24 Ay Vade</Text><br/>
            <LineTwo /><br/>
            <Container wrap={ContainerWrap.always}>
                <Text appearance={TextAppearance.copy0200} bold>
                    Kullanılan kredi tutarı
                </Text>
                <Text appearance={TextAppearance.copy0150}>
                    37.995,00 TL
                </Text><br/>
                <Line/><br/>
                <Text appearance={TextAppearance.copy0200} bold>
                  Aylık ödenecek tutar
                </Text>
                <Text appearance={TextAppearance.copy0150}>
                    3.402,00 TL
                </Text><br/>
                <Line/><br/>
                <Text appearance={TextAppearance.copy0200} bold>
                Faiz Oranı
                </Text>
                <Text appearance={TextAppearance.copy0150}>
                1,19
                </Text><br/>
            </Container><br/>
            
            <Container gutter={ContainerGutter.static300} wrap={ContainerWrap.always}><Button appearance={ButtonAppearance.Secondary}><Download/>PDF İndir</Button>
                <Button appearance={ButtonAppearance.Secondary}>Tekrar Hesapla</Button> 
                </Container>
                
               

            <Container 
                horizontalAlign={ContainerHorizontalAlignment.center}
            >

            <Mail/><Text color={TextColor.primary}>&nbsp;E-mail Gönder</Text>
            <Fax/><Text color={TextColor.primary}>&nbsp;Yazdır</Text>
            </Container>
                   </Container>
                </Container>
                </div>
                </div>
            )
        }
    }




}

export default ModelTakeCredit;

const dataListMode1 = (props) => [
    {
        'title': 'Caddy',
        'image': caddy
    },
    {
        'title': 'Transporter',
        'image': transporter
    },
    {
        'title': 'Amarok',
        'image': amarok,
    },
    {
        'title': 'Caravelle',
        'image': transporter,
    },
    {
        'title': 'Crafter',
        'image': crafter,
    },
]

const globalPadding = {
    [Breakpoints.b1920]: ContainerPadding.grid007,
    [Breakpoints.b1600]: ContainerPadding.grid006,
    [Breakpoints.b1280]: ContainerPadding.grid005,
    [Breakpoints.b960]: ContainerPadding.grid004,
    [Breakpoints.default]: ContainerPadding.grid002
}

const padding4Dimensions = {
    left: globalPadding,
    right: globalPadding,
    bottom: ContainerPadding.dynamic0100
}

const leftContainerPadding = {
    left: {
        [Breakpoints.default]: ContainerPadding.grid002,
        [Breakpoints.b960]: ContainerPadding.grid004,
        [Breakpoints.b1280]: ContainerPadding.grid002
    },
    right: {
        [Breakpoints.default]: ContainerPadding.grid002,
        [Breakpoints.b960]: ContainerPadding.grid004,
        [Breakpoints.b1280]: ContainerPadding.grid001
    }
}

const containerPadding = {
    left: {
        [Breakpoints.default]: ContainerPadding.grid002,
        [Breakpoints.b960]: ContainerPadding.grid004,
        [Breakpoints.b1600]: ContainerPadding.grid005
    },
    right: {
        [Breakpoints.default]: ContainerPadding.grid002,
        [Breakpoints.b960]: ContainerPadding.grid004,
        [Breakpoints.b1600]: ContainerPadding.grid005
    },
    top: ContainerPadding.dynamic0300
}

const dealerList = [
    {carName:'Amarok',
    id:'1',
    modelName:'Amarok'},
    {carName:'Caddy',
    id:'2',
    modelName:'Caddy'},
    {carName:'Caravelle',
    id:'3',
    modelName:'Caravelle'},
]

const vadeList = [
    {id:'1',vadeName:'12'},
    {id:'2',vadeName:'18'},
    {id:'3',vadeName:'24'},
    {id:'3',vadeName:'32'},
    {id:'3',vadeName:'48'},

]